<template>
    <button
        type="button"
        role="button"
        class="a-button-switcher button-switcher"
        :class="[{'button-switcher--active': !disabled}, `button-switcher--${mode}`]"
        :disabled="disabled"
        @click="handleClick"
    >
        <span class="button-switcher__text">
            {{ text }}
        </span>
        <svg-icon
            class="button-switcher__icon"
            original
            :name="`icons/arrow-${mode}`"
        />
    </button>
</template>

<script>
export default {
    name: 'AButtonSwitcher',
    props: {
        mode: {
            type: String,
            default: 'right'
        },
        text: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            this.$emit('onClick', true);
        }
    }
}
</script>

<style lang="scss">
@import "a-button-switcher";
</style>